import { useMemo } from 'react';
import { useDebouncedValue } from '../../../hooks/use-debounced-value.ts';
import { getHomeModelCorners } from '../utils/coords-math.ts';

interface UseHomeModelCornersProps {
  selectedHomeObjectWidth: number | null | undefined;
  selectedHomeObjectLength: number | null | undefined;
  homePlacementLatitude: number;
  homePlacementLongitude: number;
  homePlacementRotation: number;
}

export const useHomeModelCorners = (props: UseHomeModelCornersProps) => {
  const debouncedProps = useDebouncedValue(props, 100);

  const homeModelCornerCoordinates = useMemo(() => {
    const {
      selectedHomeObjectWidth,
      selectedHomeObjectLength,
      homePlacementLatitude,
      homePlacementLongitude,
      homePlacementRotation,
    } = debouncedProps;
    return getHomeModelCorners(
      selectedHomeObjectWidth,
      selectedHomeObjectLength,
      homePlacementLatitude,
      homePlacementLongitude,
      homePlacementRotation
    );
  }, [debouncedProps]);

  return {
    homeModelCornerCoordinates,
  };
};
